import React from 'react'
import { Link } from 'react-router-dom'
import SEO from '../../Components/SEO'

const FreezerTitle = ({ title = "Services", breadcrumbItems = [], seoTitle, seoDescription, seoKeywords, seoImage, seoStructuredData }) => {
  // Default breadcrumb if not provided
  const defaultBreadcrumb = [
    { label: "Home", path: "/" },
    { label: "Services", path: "/services-overview" },
    { label: title, path: "#" }
  ];
  
  const breadcrumbs = breadcrumbItems.length > 0 ? breadcrumbItems : defaultBreadcrumb;

  // Default SEO values if not provided
  const defaultSeoTitle = seoTitle || `${title} Dubai | Best ${title} Services in Dubai, UAE - KD General Transport`
  const defaultSeoDescription = seoDescription || `Best ${title} services in Dubai, UAE by KD General Transport. Professional ${title} in Dubai serving Downtown Dubai, JBR, Business Bay, Dubai Marina & All Areas. 24/7 Service. Call +971555592206`
  const defaultSeoKeywords = seoKeywords || `${title.toLowerCase()} Dubai, ${title.toLowerCase()} UAE, best ${title.toLowerCase()} Dubai, ${title.toLowerCase()} services Dubai, transportation services Dubai, transport services Dubai`

  return (
    <div>
      <SEO
        title={defaultSeoTitle}
        description={defaultSeoDescription}
        keywords={defaultSeoKeywords}
        image={seoImage}
        structuredData={seoStructuredData}
        breadcrumbs={breadcrumbs}
      />
      <div className="page-title-style01 page-title-negative-top pt-bkg04">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <h1>{title}</h1>
              <div className="breadcrumb-container">
                <ul className="breadcrumb clearfix">
                  <li>You are here:</li>
                  {breadcrumbs.map((item, index) => (
                    <li key={index}>
                      {item.path === "#" ? (
                        <span>{item.label}</span>
                      ) : (
                        <Link to={item.path}>{item.label}</Link>
                      )}
                    </li>
                  ))}
                </ul>
                {/* .breadcrumb end */}
              </div>
              {/* .breadcrumb-container end */}
            </div>
            {/* .col-md-12 end */}
          </div>
          {/* .row end */}
        </div>
        {/* .container end */}
      </div>
    </div>
  )
}

export default FreezerTitle
